<template>
  <a-modal v-model="modal" title="选择计划版本" width="480px" :maskClosable="false" :closable="false" :destroyOnClose="true">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="计划版本号"
        :labelCol="{ style: 'width: 110px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 110px ) !important;float:left'}"
        prop="version"
        :rules="rules.version"
      >
        <global-select
          ref="versionRef"
          searchParam="version"
          selectType="selectSearch"
          :allow-clear="false"
          :default-active-first-option="true"
          :value.sync="formData.version"
          requestApi="/scp/scpMpsPlansOrderFd/refreshVersionComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiScpRefreshPlanOrderFd } from '@/api/finished-goods-order'

export default {
  name: 'CreatePlanModal',
  data() {
    return {
      modal: false,
      formData: { version: '' },
      loading: false,
      rules: {
        version: [{ required: true, message: ' ', trigger: 'change' }]
      }
    }
  },
  methods: {
    show () {
      this.$set(this.formData, 'version', '')
      this.modal = true
    },
    // 提交
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiScpRefreshPlanOrderFd({ version: this.formData.version }).then(res => {
            if (res?.code === 200) {
              this.$message.success('操作成功')
              this.$emit("finallyUpdate")
              this.modal = false
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
